import React from "react";
import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";
import { DEFAULT_DATETIME_FORMAT } from "globals/constants";
import moment from "moment";

import { Table } from "semantic-ui-react";

import styles from "../../SummaryBudget.css";

export const UploadFooter = ({ config, UploadComponent, onChange, ...rest }) => {
	return (
		<>
			<div className={`${styles.label}`}>
				<label>Detailed Budget</label>
			</div>
			<div>
				{config.attachmentDescription}
			</div>
			<Table singleLine>
				<caption>Detailed Budget</caption>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell>Name</Table.HeaderCell>
						<Table.HeaderCell>Uploaded By</Table.HeaderCell>
						<Table.HeaderCell>Date</Table.HeaderCell>
					</Table.Row>
				</Table.Header>
				{ isNonEmptyArray(config?.value?.file)
					?
					<Table.Body>
						<Table.Row>
							<Table.Cell>{config.value?.file[0]?.name}</Table.Cell>
							<Table.Cell>
								{`${config.value?.uploadUser?.firstName} ${config.value?.uploadUser?.lastName}`}
							</Table.Cell>
							<Table.Cell>
								{moment(config.value?.file[0]?.lastModified).format(DEFAULT_DATETIME_FORMAT)}
							</Table.Cell>
						</Table.Row>
					</Table.Body>
					:
					<Table.Body>
						<Table.Row>
							<Table.Cell colSpan="3" textAlign={"center"} className={styles.emptyUploadInfo}>
								<i>No budget found. Upload a budget .xls below</i>
							</Table.Cell>
						</Table.Row>
					</Table.Body>
				}
			</Table>
			<UploadComponent
				{...rest}
				config={config.resolvedUpload}
				onChange={value => onChange( { $path: config.resolvedUpload.$path, $value: value })}
			/>
		</>
	);
};

export default UploadFooter;